module.exports = __webpack_public_path__ + "static/media/mountains.14889fc1.jpg";